import {
	initMap,
	equalCols,
	togglePlayPause
} from "../functions";
import Typed from "typed.js";

$(document).ready(function () {
	const hasFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

	if (hasFinePointer) {
		const themeCursor = document.createElement('div');
		let cursorFrame = null;
		let cursorX = 0;
		let cursorY = 0;

		themeCursor.className = 'theme-cursor';
		themeCursor.setAttribute('aria-hidden', 'true');
		document.body.appendChild(themeCursor);

		const updateThemeCursor = function (target) {
			const footerHome = target.closest('.footer-home');
			const footerBottom = target.closest('.footer-bottom');
			const themeContainer = target.closest('[data-bs-theme]');

			if (!themeContainer && !footerHome && !footerBottom) {
				themeCursor.classList.remove('is-visible', 'is-dark', 'is-light', 'is-footer-bottom');
				document.body.classList.remove('has-theme-cursor');
				return;
			}

			const theme = themeContainer ? themeContainer.getAttribute('data-bs-theme') : null;
			themeCursor.classList.add('is-visible');
			themeCursor.classList.toggle('is-dark', theme === 'dark' || Boolean(footerHome));
			themeCursor.classList.toggle('is-light', theme === 'light');
			themeCursor.classList.toggle('is-footer-bottom', Boolean(footerBottom));
			document.body.classList.add('has-theme-cursor');
		};

		const moveThemeCursor = function () {
			themeCursor.style.left = cursorX + 'px';
			themeCursor.style.top = cursorY + 'px';
			cursorFrame = null;
		};

		document.addEventListener('mousemove', function (event) {
			cursorX = event.clientX;
			cursorY = event.clientY;
			updateThemeCursor(event.target);

			if (!cursorFrame) {
				cursorFrame = window.requestAnimationFrame(moveThemeCursor);
			}
		});

		document.documentElement.addEventListener('mouseleave', function () {
			themeCursor.classList.remove('is-visible');
			document.body.classList.remove('has-theme-cursor');
		});
	}

	$(document).on('click', '.tab-circle-box', function () {
		var id = $(this).data("id");

		$('.box-center-text').css('opacity', 0);
		$('.box-center-text-' + id).css('opacity', 1);
	});

	$(document).on("click", ".portfolio-category-btn", function (e) {
		var id = $(this).data("id");
		var mid = $(this).data("mid");

		$(this).parent().parent().find('.swiper-slide').removeClass('swiper-slide-active');
		$(this).parent().addClass('swiper-slide-active');

		var values = '_token=' + $("meta[name='csrf-token']").attr("content");
		values += '&id=' + id;
		$.ajax({
			type: "POST",
			url: baseURL + "/portfolios/get-items",
			data: values,
			success: function (html) {
				$('#portofoliu-slider-' + mid).html(html);;
				$(".portofoliu-slider").slick({
					slidesToShow: 2,
					slidesToScroll: 1,
					adaptiveHeight: true,
					responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							dots: true,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							dots: true,
							arrows: false,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							dots: true,
							arrows: false,
						},
					},
						// You can unslick at a given breakpoint now by adding:
						// settings: "unslick"
						// instead of a settings object
					],
				});
			},
			error(error) {
				console.log(error);
			}
		});
	});

	$(document).on("click", ".show-sublinks-btn", function (e) {
		e.preventDefault();
		var id = $(this).data("id");

		var openText = $('.new-menu-toggler').data('open-text');
		$(".header").removeClass("header-opened");
		$(".header-menu-new").removeClass("header-menu-opened");
		$(".new-menu-toggler").html("<i class='fal fa-bars icon'></i>" + "<span class='text'>" + openText + "</span>");
		$('.logo-desktop').attr('src', baseURL + '/images/logo.png')

		if ($("#sublinks-container-" + id).css("display") == "none") {
			$("#sublinks-container-" + id).show();
			$(".header").removeClass("header-fix");
			$(".content-container").removeClass("mc-padding-top");
		} else {
			$("#sublinks-container-" + id).hide();
			$(".header").addClass("header-fix");
			$(".content-container").addClass("mc-padding-top");
		}
	});

	// HEADING ANIMATION
	// build tween
	var controllerHeading = new ScrollMagic.Controller();
	var timelineText = new TimelineLite();

	if ($(".animated-heading").length > 0) {
		if ($(window).width() < 768) {
			timelineText
				.set(".animated-heading", {
					x: "10%",
					y: "0%"
				}) //  center the element
				.to(".animated-heading", 1, {
					x: -500,
					y: 0,
					z: -20,
					ease: "slow"
				}); // move it to the desired position
		} else {
			timelineText
				.set(".animated-heading", {
					x: "20%",
					y: "0%"
				}) //  center the element
				.to(".animated-heading", 1, {
					x: -300,
					y: 0,
					z: -20,
					ease: "circ.out",
				}); // move it to the desired position
		}

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: ".animated-heading",
			duration: 500,
		})
			.setTween(timelineText)
			.addTo(controllerHeading);
	}

	// HEADING ANIMATION

	// BANNER ANIMATION
	// init
	var controller = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: "onLeave",
			duration: "200%", // this works just fine with duration 0 as well
			// However with large numbers (>20) of pinned sections display errors can occur so every section should be unpinned once it's covered by the next section.
			// Normally 100% would work for this, but here 200% is used, as Panel 3 is shown for more than 100% of scrollheight due to the pause.
		},
	});

	var tl = new TimelineMax();
	tl.fromTo(".section-panel", {
		opacity: 1
	}, {
		opacity: 0,
		duration: 1
	});
	// get all slides
	var slides = document.querySelectorAll(".section-panel");

	// create scene for every slide
	for (var i = 0; i < slides.length; i++) {
		new ScrollMagic.Scene({
			triggerElement: slides[i],
		})
			.setPin(slides[i], {
				pushFollowers: false
			})
			.setTween(tl)
			.addTo(controller);
	}
	// BANNER ANIMATION

	// CHART ANIMATION
	var chartElements = document.getElementsByClassName("waypoint-chart");
	for (var i = 0; i < chartElements.length; i++) {
		new Waypoint({
			element: chartElements[i],
			handler: function (direction) {
				let dataValue = this.element.getAttribute("data-end");
				$(this.element).toggleClass("active");
				if ($(this.element).hasClass("active")) {
					this.element.style.width = dataValue;
				} else {
					this.element.style.width = "0%";
				}
			},
			offset: "right-in-view",
		});
	}
	// CHART ANIMATION

	// TYPING ANIMATION
	if ($(".animated-title").length > 0) {
		var animatedTitle = $(".animated-title").data("title");
		var options = {
			strings: [animatedTitle],
			typeSpeed: 40,
			backSpeed: 40,
			backDelay: 500,
			shuffle: true,
			loop: true,
		};

		var typed = new Typed(".animated-title", options);
	}
	// TYPING ANIMATION

	//initialize swiper when document ready
	if ($(".swiper-testimonial").length > 0) {
		var swiperTestimonial = new Swiper(".swiper-testimonial", {
			// Optional parameters
			//   direction: 'vertical',
			// Navigation arrows
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			loop: true,
		});
	}

	//initialize swiper when document ready
	if ($(".swiper-portfolio--category").length > 0) {
		var swiperPortfolioCategory = new Swiper(".swiper-portfolio--category", {
			slidesPerView: 'auto',
			spaceBetween: 15,
			freeMode: true,
			centerInsufficientSlides: true,
			// Optional parameters
			//   direction: 'vertical',
			// Navigation arrows
			// navigation: {
			// 	nextEl: ".swiper-button-next",
			// 	prevEl: ".swiper-button-prev",
			// },
			// loop: true,
		});
	}
	if ($(".swiper-roles").length > 0) {
		var swiperRoles = new Swiper(".swiper-roles", {
			slidesPerView: 1,
			grid: {
				rows: 2,
				fill: 'row',
			},
			spaceBetween: 30,
			navigation: {
				nextEl: ".role-next",
				prevEl: ".role-prev",
			},
			breakpoints: {
				768: {
					slidesPerView: 1,
				},
				992: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},
		});
	}



	if ($('.swiper--hero').length > 0) {

		let swiperHero = new Swiper(".swiper--hero", {
			slidesPerView: 1,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: ".swiper-hero-next",
				prevEl: ".swiper-hero-prev",
			},
		});
	}

	if ($('.swiper--projects-featured').length > 0) {

		let swiperProjectsFeatured = new Swiper(".swiper--projects-featured", {
			slidesPerView: 1,
			effect: 'fade',
			navigation: {
				nextEl: ".swiper-featured-next",
				prevEl: ".swiper-featured-prev",
			},
		});
	}

	if ($('.swiper-projects--scrolled').length > 0) {

		let swiperProjectsScrolled = new Swiper(".swiper-projects--scrolled", {
			slidesPerView: 1,
			spaceBetween: 40,
			// centeredSlides: true,
			loop: true,
			effect: 'cards',
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					allowTouchMove: false,
					freeMode: 'true',
					slidesPerView: 'auto',
				},
			},
		});
	}

	// if ($('.swiper-projects--scrolled-2').length > 0) {
	// 	let swiperProjectsScrolled2 = new Swiper(".swiper-projects--scrolled-2", {
	// 		slidesPerView: 1,
	// 		spaceBetween: 40,
	// 		// centeredSlides: true,
	// 		loop: true,
	// 		effect: 'cards',
	// 		breakpoints: {
	// 			768: {
	// 				slidesPerView: 2,
	// 			},
	// 			1200: {
	// 				allowTouchMove: false,
	// 				freeMode: 'true',
	// 				slidesPerView: 'auto',
	// 			},
	// 		},
	// 	});
	// }

	if ($(window).width() > 1200) {
		window.addEventListener('scroll', function () {
			var scrollAmount = window.pageYOffset || document.documentElement.scrollTop;
			var sliderSection = document.querySelector('.template-boxes--sliding')
			var sliderElement1 = document.querySelector('.swiper-projects--scrolled');
			var sliderElement2 = document.querySelector('.swiper-projects--scrolled-2');
			if (sliderSection) {
				var sliderOffset = sliderSection.offsetTop;
				var windowHeight = window.innerHeight;

				if (scrollAmount >= sliderOffset - windowHeight) {
					var scrollDelta = scrollAmount - sliderOffset;
					var translateValue1 = -scrollDelta * 1; // Adjust the translation speed as needed
					var translateValue2 = scrollDelta * 1; // Adjust the translation speed as needed

					sliderElement1.style.transform = 'translate3d(' + translateValue1 + 'px, 0, 0)';
					sliderElement2.style.transform = 'translate3d(' + translateValue2 + 'px, 0, 0)';
				}
			}
		});
	}


	if ($('.swiper--gallery').length > 0) {

		let swiperGallery = new Swiper(".swiper--gallery", {
			slidesPerView: 'auto',
			centeredSlides: true,
			loop: true,
			speed: 1000,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: ".pagination-gallery",
				// dynamicBullets: true,
				clickable: true,
			},
		});
	}

	if ($('.swiper--products').length > 0) {

		let swiperProducts = new Swiper(".swiper--products", {
			slidesPerView: 1,
			// loop: true,
			// autoHeight: true,
			spaceBetween: 15,
			slideToClickedSlide: true,
			// autoplay: {
			// 	delay: 5000,
			// 	disableOnInteraction: false,
			// },
			pagination: {
				el: ".pagination-products",
				// dynamicBullets: true,
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 'auto',
					spaceBetween: 50,
				},
				992: {
					slidesPerView: 'auto',
					spaceBetween: 50,
				},
				1200: {
					slidesPerView: 'auto',
					spaceBetween: 50,
				},
			},
		});
	}

	if ($(".gallery-thumbs").length > 0) {
		var galleryThumbs = new Swiper(".gallery-thumbs", {
			spaceBetween: 10,
			slidesPerView: 2,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					slidesPerView: 4,
					spaceBetween: 40,
				},
				1024: {
					slidesPerView: 6,
					spaceBetween: 50,
				},
			},
			navigation: {
				nextEl: ".swiper-project-next",
				prevEl: ".swiper-project-prev",
			},
		});
		var galleryTop = new Swiper(".gallery-top", {
			spaceBetween: 0,
			navigation: {
				nextEl: ".swiper-button-next--gallery",
				prevEl: ".swiper-button-prev--gallery",
			},
			thumbs: {
				swiper: galleryThumbs,
			},
		});
	}

	$(".portofoliu-slider").slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false,
			},
		},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	});

	$(".slider-proiect").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		adaptiveHeight: true,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
				arrows: false,
			},
		},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	});

	$(".slider-events").slick({
		dots: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				dots: true,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: false,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
			},
		},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	});
	$(".slider-clienti").slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		centerMode: true,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				dots: false,
			},
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: false,
				centerMode: false,
				dots: false,
			},
		},
		{
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
				arrows: true,
				centerMode: false,
				dots: false,
			},
		},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	});

	$(".slider-more-projects-mobile").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
	});

	$(".slider-otherarticles-mobile").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
	});

	$(".newsletter-section .checkmark.fa-square").click(function () {
		$(this).toggleClass("fa-square");
		$(".newsletter-section .checkmark").addClass("fa-check-square");
	});
	$("label[for='newsletter-terms-and-condition']").click(function () {
		$(".newsletter-section .checkmark")
			.toggleClass("fa-square")
			.toggleClass("fa-check-square");
	});

	$(".dropdown-contact").click(function () {
		$(".dropdown-contact .dropdown-menu-interest").toggleClass("is-opened");
	});

	$(".hamburger-mobile").click(function (e) {
		e.preventDefault();
		$(".navbar-mobile").toggleClass("opened");
	});
	$(".navbar-mobile .menu-button").click(function () {
		$(".navbar-mobile").toggleClass("opened");
	});

	$(".submenu-navigation .link").hover(function () {
		$(this).toggleClass("opened");
	});

	$(".links-section .link").hover(function () {
		$(this).css("background", "none");
		$(this).html("");
	});

	$(".submenu-link").hover(
		function () {
			var iconHover = $(this).data("icon-hover");
			if (iconHover != "") {
				iconHover += " icon-level-1";
				$(this)
					.find("i")
					.removeClass()
					.addClass(iconHover);
			}
		},
		function () {
			var iconMain = $(this).data("icon");
			if (iconMain != "") {
				iconMain += " icon-level-1";
				$(this)
					.find("i")
					.removeClass()
					.addClass(iconMain);
			}
		}
	);
	$(".sub-submenu-link").hover(
		function () {
			var iconHover = $(this).data("icon-hover");
			if (iconHover != "") {
				iconHover += " icon";
				$(this)
					.find("i")
					.removeClass()
					.addClass(iconHover);
			}
		},
		function () {
			var iconMain = $(this).data("icon");
			if (iconMain != "") {
				iconMain += " icon";
				$(this)
					.find("i")
					.removeClass()
					.addClass(iconMain);
			}
		}
	);

	$(".portofoliu-nav-list li").click(function () {
		$(".portofoliu-nav-list li").removeClass("active");
		$(this).addClass("active");
	});

	$(".toggle-submenu").click(function (e) {
		e.preventDefault();
		// $(".portofoliu-nav-list li").removeClass("active");
		$(this)
			.siblings(".sublinks")
			.slideToggle();
	});

	var chartDonuts = document.getElementsByClassName("donut-segment");
	for (var i = 0; i < chartDonuts.length; i++) {
		let donutCtr = i;
		new Waypoint({
			element: chartDonuts[i],
			handler: function (direction) {
				// let dataValue = this.element.getAttribute('data-end');
				$(this.element).toggleClass(`donut${donutCtr}`);
			},
			offset: "right-in-view",
		});
	}

	$(document).on('click', '.new-menu-toggler', function () {
		var openText = $(this).data('open-text');
		var closeText = $(this).data('close-text');

		$(".header").toggleClass("header-opened");
		$(".header-menu-new").toggleClass("header-menu-opened");

		if ($(".header").hasClass("header-opened")) {
			$(".new-menu-toggler").html("<span class='text'>" + closeText + "</span>");
			$(".new-menu-toggler").toggleClass('active');
		} else {
			$(".new-menu-toggler").html("<span class='text'>" + openText + "</span>");
			$(".new-menu-toggler").toggleClass('active');
		}
	});

	if ($(".template-boxes--sliding").length > 0 && $(window).width() < 1200) {
		$(".template-boxes--sliding .card-absolute").click(function () {
			// $(".portofoliu-nav-list li").removeClass("active");
			$(this).toggleClass("active");
		});
	}

	// Attach the event listener to all buttons with the 'data-target' attribute
	var buttons = document.querySelectorAll('.btn-play[data-target]');
	// console.log(buttons);
	buttons.forEach(function (button) {
		button.addEventListener('click', togglePlayPause);
	});



});

$(window).scroll(function () {
	if ($(this).scrollTop() > 124) {
		$(".submenu-navigation").addClass("fixed");
	} else {
		$(".submenu-navigation").removeClass("fixed");
	}
});

$(document).ready(function () {
	var $slider = $('.slider-clienti-one-row').not('.customers-slide.v2 .slider-clienti-one-row');

	$slider.on('init afterChange', function (event, slick, currentSlide) {
		var current = typeof currentSlide === 'number' ? currentSlide : slick.currentSlide;
		var total = slick.slideCount;
		var visible = slick.options.slidesToShow || 1;
		var lastIndex = Math.max(total - visible, 0);

		var $prev = $(slick.$prevArrow);
		var $next = $(slick.$nextArrow);

		if (current === 0) {
			$prev.hide();
		} else {
			$prev.show();
		}

		if (current >= lastIndex) {
			$next.hide();
		} else {
			$next.show();
		}
	});

	$slider.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		arrows: true,
		dots: false,
		autoplay: true,
		autoplaySpeed: 1000,
		speed: 500,
		pauseOnHover: true,
		swipe: true,
		draggable: true,
		responsive: [
			{
				breakpoint: 992,
				settings: { slidesToShow: 3 }
			},
			{
				breakpoint: 767,
				arrows: false,
			},
			{
				breakpoint: 576,
				settings: { slidesToShow: 2 }
			}
		]
	});
});

$(document).ready(function () {
	var sliderNews = new Swiper('.slider-news', {
		// fallback (dacă nu prinde niciun breakpoint)
		slidesPerView: 1.1,
		spaceBetween: 20,
		loop: false,
		navigation: false,
		pagination: false,
		allowTouchMove: true,

		breakpoints: {
			// telefoane mici
			0: {
				slidesPerView: 1.2,
				spaceBetween: 16
			},
			// telefoane mari / mici landscape
			576: {
				slidesPerView: 1.4,
				spaceBetween: 20
			},
			// tablete
			768: {
				slidesPerView: 1.5,
				spaceBetween: 24
			},
			// laptopuri / desktop mediu
			1024: {
				slidesPerView: 2.45,
				spaceBetween: 30
			},
			// monitoare mari
			1440: {
				slidesPerView: 3.45,
				spaceBetween: 30
			}
		}
	});
});

$(document).ready(function () {
	var sliderProjects = new Swiper('.slider-projects', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},

		navigation: {
			nextEl: '.slider-projects-next',
			prevEl: '.slider-projects-prev',
		},
		pagination: false,
	});
});

$(document).ready(function () {
	const swiper = new Swiper('.testimonial-swiper', {
		slidesPerView: 1,
		spaceBetween: 0,
		centeredSlides: false,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: false,
	});
});

$(document).ready(function () {
	var gallerySwiper = new Swiper('.gallerySwiper', {
		slidesPerView: 2.3,
		centeredSlides: true,
		spaceBetween: 20,
		loop: true,

		navigation: {
			nextEl: '.gallery-next',
			prevEl: '.gallery-prev',
		},
		breakpoints: {
			0: {
				slidesPerView: 1.3,
				centeredSlides: true,
			},
			768: {
				slidesPerView: 1.6,
				centeredSlides: true,
			},
			1024: {
				slidesPerView: 2.3,
				centeredSlides: true,
			},
			1366: {
				slidesPerView: 3.25,
				centeredSlides: true,
			}
		}
	});
});

$(document).ready(function () {
	if ($('.tabs-video-sliders').length > 0) {
		const slider = document.querySelector('.tabs-video-sliders');
		if (slider) {
			let isDown = false;
			let startX;
			let scrollLeft;

			slider.addEventListener('mousedown', e => {
				isDown = true;
				slider.style.cursor = 'grabbing';
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
			});

			slider.addEventListener('mouseleave', () => {
				isDown = false;
				slider.style.cursor = 'grab';
			});

			slider.addEventListener('mouseup', () => {
				isDown = false;
				slider.style.cursor = 'grab';
			});

			slider.addEventListener('mousemove', e => {
				if (!isDown) return;
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = (x - startX) * 2;
				slider.scrollLeft = scrollLeft - walk;
			});
		}
	}
});


document.addEventListener('DOMContentLoaded', function () {
	new Swiper('.team-swiper', {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: false,

		navigation: {
			nextEl: '.team-swiper .swiper-button-next',
			prevEl: '.team-swiper .swiper-button-prev',
		},

		speed: 600,
	});
});


document.addEventListener('DOMContentLoaded', function () {
	new Swiper('.center-swiper', {
		slidesPerView: 3,
		centeredSlides: true,
		spaceBetween: 16,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slideToClickedSlide: true,
		breakpoints: {
			0: {
				slidesPerView: '2.3',
				centeredSlides: true,
				spaceBetween: 12,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			}
		}
	});
});



document.addEventListener('DOMContentLoaded', function () {
	const partnersTestimonialsSwiper = new Swiper('.swiper-partners-testimonials', {
		slidesPerView: 1,
		spaceBetween: 40,
		loop: true,

		navigation: {
			nextEl: '.swiper-partners-testimonials-next',
			prevEl: '.swiper-partners-testimonials-prev',
		},
		breakpoints: {
			0: {
				spaceBetween: 12,
			},
			768: {
				spaceBetween: 16,
			},
			1024: {
				spaceBetween: 40,
			}
		}
	});
});


document.addEventListener('DOMContentLoaded', function () {
	const linksSwiperEl = document.querySelector('.links-swiper');
	if (!linksSwiperEl) return;

	const speed = window.matchMedia('(max-width: 767px)').matches ? 3000 : 5000;

	new Swiper(linksSwiperEl, {
		slidesPerView: 'auto',
		spaceBetween: 20,
		loop: true,
		freeMode: true,
		freeModeMomentum: false,
		speed: speed,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		allowTouchMove: false
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const wrapper = document.getElementById('heroVideoTextWrapper');
	if (wrapper) {
		const video = document.getElementById('heroVideoText');

		const playBtn = document.getElementById('playPauseToggleText');
		const volumeBtn = document.getElementById('volumeToggleText');

		const playIcon = playBtn.querySelector('i');
		const volumeIcon = volumeBtn.querySelector('i');

		video.muted = true;
		let userPaused = false;

		function setPlayIcon(isPlaying) {
			playIcon.classList.remove('fa-play', 'fa-pause');
			playIcon.classList.add(isPlaying ? 'fa-pause' : 'fa-play');
		}

		async function safePlay() {
			try {
				await video.play();
				setPlayIcon(true);
			} catch (e) {
				setPlayIcon(false);
			}
		}

		function safePause() {
			video.pause();
			setPlayIcon(false);
		}

		playBtn.addEventListener('click', function (e) {
			e.preventDefault();

			if (video.paused) {
				userPaused = false;
				safePlay();
			} else {
				userPaused = true;
				safePause();
			}
		});

		volumeBtn.addEventListener('click', function (e) {
			e.preventDefault();

			video.muted = !video.muted;

			volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
			volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;

				if (inView) {
					if (!userPaused) safePlay();
				} else {
					safePause();
				}
			});
		}, {
			threshold: [0, 0.5, 1.0]
		});

		observer.observe(wrapper);

		setPlayIcon(false);
		volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
		volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
	}
});

document.addEventListener('DOMContentLoaded', function () {
	const wrapper = document.getElementById('heroVideoTextLeftLeftWrapper');
	if (wrapper) {
		const video = document.getElementById('heroVideoTextLeft');

		const playBtn = document.getElementById('playPauseToggleTextLeft');
		const volumeBtn = document.getElementById('volumeToggleTextLeft');

		const playIcon = playBtn.querySelector('i');
		const volumeIcon = volumeBtn.querySelector('i');

		video.muted = true;

		let userPaused = false;

		function setPlayIcon(isPlaying) {
			playIcon.classList.remove('fa-play', 'fa-pause');
			playIcon.classList.add(isPlaying ? 'fa-pause' : 'fa-play');
		}

		async function safePlay() {
			try {
				await video.play();
				setPlayIcon(true);
			} catch (e) {
				setPlayIcon(false);
			}
		}

		function safePause() {
			video.pause();
			setPlayIcon(false);
		}

		playBtn.addEventListener('click', function (e) {
			e.preventDefault();

			if (video.paused) {
				userPaused = false;
				safePlay();
			} else {
				userPaused = true;
				safePause();
			}
		});

		volumeBtn.addEventListener('click', function (e) {
			e.preventDefault();

			video.muted = !video.muted;

			volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
			volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;

				if (inView) {
					if (!userPaused) safePlay();
				} else {
					safePause();
				}
			});
		}, {
			threshold: [0, 0.5, 1.0]
		});

		observer.observe(wrapper);

		setPlayIcon(false);
		volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
		volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
	}
});


document.addEventListener('DOMContentLoaded', function () {
	const wrapper = document.getElementById('heroVideoWrapper');
	if (wrapper) {
		const video = document.getElementById('heroVideo');

		const playBtn = document.getElementById('playPauseToggle');
		const volumeBtn = document.getElementById('volumeToggle');

		const playIcon = playBtn.querySelector('i');
		const volumeIcon = volumeBtn.querySelector('i');

		video.muted = true;

		let userPaused = false;

		function setPlayIcon(isPlaying) {
			playIcon.classList.remove('fa-play', 'fa-pause');
			playIcon.classList.add(isPlaying ? 'fa-pause' : 'fa-play');
		}

		async function safePlay() {
			try {
				await video.play();
				setPlayIcon(true);
			} catch (e) {
				setPlayIcon(false);
			}
		}

		function safePause() {
			video.pause();
			setPlayIcon(false);
		}

		playBtn.addEventListener('click', function (e) {
			e.preventDefault();

			if (video.paused) {
				userPaused = false;
				safePlay();
			} else {
				userPaused = true;
				safePause();
			}
		});

		volumeBtn.addEventListener('click', function (e) {
			e.preventDefault();

			video.muted = !video.muted;

			volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
			volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				const inView = entry.isIntersecting && entry.intersectionRatio >= 0.5;

				if (inView) {
					if (!userPaused) safePlay();
				} else {
					safePause();
				}
			});
		}, {
			threshold: [0, 0.5, 1.0]
		});

		observer.observe(wrapper);

		setPlayIcon(false);
		volumeIcon.classList.remove('fa-volume', 'fa-volume-slash');
		volumeIcon.classList.add(video.muted ? 'fa-volume-slash' : 'fa-volume');
	}
});


document.addEventListener('DOMContentLoaded', function () {

	document.querySelectorAll('.video-round-swiper .video-item').forEach(slide => {
		const video = slide.querySelector('video');
		const overlay = slide.querySelector('.video-overlay');
		const playIcon = overlay.querySelector('.play-button i');

		overlay.addEventListener('click', function () {
			// // Allow play/pause only on the active Swiper slide
			// if (!slide.classList.contains('swiper-slide-active')) {
			// 	return;
			// }

			if (video.paused) {
				video.play();
				playIcon.classList.remove('fa-play');
				playIcon.classList.add('fa-pause');
			} else {
				video.pause();
				playIcon.classList.remove('fa-pause');
				playIcon.classList.add('fa-play');
			}
		});

		// When the video ends, switch back to the Play icon
		video.addEventListener('ended', function () {
			playIcon.classList.remove('fa-pause');
			playIcon.classList.add('fa-play');
		});
	});

	new Swiper('.video-round-swiper', {
		centeredSlides: true,
		slidesPerView: 5.5,
		spaceBetween: 12,
		speed: 450,

		loop: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			type: 'bullets',
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			0: { slidesPerView: 1.2 },
			480: { slidesPerView: 2.2 },
			768: { slidesPerView: 3.2 },
			1025: { slidesPerView: 3.2 },
			1441: { slidesPerView: 5.5 },
		},

		on: {
			slideChange: function () {
				// Pause every video that is NOT on the active slide
				this.slides.forEach((slideEl, idx) => {
					if (idx === this.activeIndex) return;

					const video = slideEl.querySelector('video');
					const playIcon = slideEl.querySelector('.play-button i');

					if (video) video.pause();
					if (playIcon) {
						playIcon.classList.remove('fa-pause');
						playIcon.classList.add('fa-play');
					}
				});
			}
		}
	});

});


document.addEventListener('DOMContentLoaded', function () {
	const logo = document.querySelector('.logo-fixed');
	if (logo) {
		function getConfig() {
			const width = window.innerWidth;

			if (width <= 767) {
				return {
					startTop: 60,
					endTop: 8,
					startScale: 1,
					endScale: 0.7,
					scrollRange: 190
				};
			}

			if (width <= 1023) {
				return {
					startTop: 80,
					endTop: 10,
					startScale: 1,
					endScale: 0.65,
					scrollRange: 260
				};
			}

			return {
				startTop: 110,
				endTop: 12,
				startScale: 1,
				endScale: 0.6,
				scrollRange: 260
			};
		}

		let config = getConfig();

		function updateLogo() {
			const scrollY = window.scrollY;
			const progress = Math.min(scrollY / config.scrollRange, 1);

			const currentTop =
				config.startTop -
				(config.startTop - config.endTop) * progress;

			const currentScale =
				config.startScale -
				(config.startScale - config.endScale) * progress;

			logo.style.top = currentTop + 'px';
			logo.style.transform = `scale(${currentScale})`;
		}

		window.addEventListener('scroll', updateLogo);

		window.addEventListener('resize', function () {
			config = getConfig();
			updateLogo();
		});

		updateLogo();
	}
});



// WEBPACK FOOTER //
// ./resources/js/regular/general.js